import { Tooltip as DefaultTooltip } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

import { COLOR_VALUES } from "shared/config/colors";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";

export const StyledToolTip = withStyles({
    tooltip: {
        background: COLOR_VALUES.Gray_1,
        color: COLOR_VALUES.White,
        borderRadius: "2px",
        margin: "8px 0",
        maxWidth: "240px",

        // Small variant
        ...TEXT_VARIANT_STYLES.Descriptive_1_1,
        padding: "2px 8px 4px",

        // Responsive for mobile screens
        '@media (max-width: 799px)': {
            maxWidth: "200px",
            fontSize: "12px",
            lineHeight: "1.3",
            padding: "4px 6px",
            margin: "4px 0",
        },
    },
    popper: {
        zIndex: 1051,
    },
})(DefaultTooltip);
